import { render, staticRenderFns } from "./booking-summary.vue?vue&type=template&id=b51dc02a&scoped=true"
import script from "./booking-summary.vue?vue&type=script&lang=js"
export * from "./booking-summary.vue?vue&type=script&lang=js"
import style0 from "./booking-summary.vue?vue&type=style&index=0&id=b51dc02a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51dc02a",
  null
  
)

export default component.exports